var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReplayPlayback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24219 2.11719H18.9089V12.9505H2.24219V2.11719Z",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16146 16.7005H3.07812M5.16146 16.7005C5.16146 16.8647 5.19379 17.0272 5.25661 17.1789C5.31943 17.3305 5.4115 17.4683 5.52757 17.5844C5.64365 17.7005 5.78145 17.7926 5.9331 17.8554C6.08476 17.9182 6.24731 17.9505 6.41146 17.9505C6.57561 17.9505 6.73816 17.9182 6.88981 17.8554C7.04147 17.7926 7.17927 17.7005 7.29534 17.5844C7.41142 17.4683 7.50349 17.3305 7.56631 17.1789C7.62913 17.0272 7.66146 16.8647 7.66146 16.7005M5.16146 16.7005C5.16146 16.369 5.29315 16.0511 5.52757 15.8166C5.762 15.5822 6.07994 15.4505 6.41146 15.4505C6.74298 15.4505 7.06092 15.5822 7.29534 15.8166C7.52976 16.0511 7.66146 16.369 7.66146 16.7005M7.66146 16.7005H18.0781M9.74479 5.86719L12.2448 7.53385L9.74479 9.20052V5.86719Z",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayPlayback);
export default __webpack_public_path__ + "static/media/ReplayPlayback.ed366d0f42a7dc990d9ced3a4b191f33.svg";
export { ForwardRef as ReactComponent };